import * as time from '@/libs/time'
import * as C from '@/consts'
import store from '@/store'

const WEEKS = ['日', '月', '火', '水', '木', '金', '土']

/**
 * CCalendar 用のカレンダー情報を作成する
 *
 * @param {Object} calendar API カレンダー情報
 * @returns {Object} CCalendar 用のカレンダー情報を返す
 */
export function createCalendar (calendar) {
  const dates = Object.keys(calendar.dates)

  const cal = {}
  for (const ymd of dates) {
    const date = calendar.dates[ymd]
    const d = time.create(date.date)

    const classes = [`c-cell--w${date.w}`]
    if (!date.opened) {
      classes.push('c-cell--closed')
    }
    if (date.holiday) {
      classes.push('c-cell--holiday')
    }
    if (date.season === C.SEASON_CAMPAIGN) {
      classes.push('c-cell--campaign')
    } else if (date.season === C.SEASON_HIGH) {
      classes.push('c-cell--high')
    }

    cal[ymd] = {
      date: date.date,

      year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDate(),

      week: WEEKS[date.w],

      begin: date.begin,
      end: date.end,

      classes: classes.join(' '),
      closed: !date.opened,
      holiday: date.holiday
    }
  }

  return {
    // 日付一覧
    dates,

    // カレンダー情報
    calendar: cal
  }
}

/**
 * CCalendar 用の各日付の状態を作成する
 *
 * @param {Array} dates 日付一覧
 * @param {Array} spans 予約可能期間一覧
 * @returns {Object} CCalendar 用の各日付の状態を返す
 *
 * 終日予約可: c-cell--empty
 * 一部予約可: c-cell--afew
 * 予約不可: c-cell--occupied
 */
export function createStates (dates, spans) {
  const states = {}
  // カレンダー表示タイプを取得
  const calendarType = store.getters['org/calendarType']

  // すべての日付を予約不可で初期化する
  for (const ymd of dates) {
    states[ymd] = 'c-cell--occupied'
  }

  for (const span of spans) {
    const begin = time.create(span.begin)
    const end = time.create(span.end)

    const beginDate = time.format('Y-m-d', begin)
    const beginTime = time.format('H:i:s', begin)
    const endDate = time.format('Y-m-d', end)
    const endTime = time.format('H:i:s', end)

    // 開始日, 終了日は一部予約可にする (改善の余地あり) ← 佐藤さんコメント
    // update 2024-10-08 出発日、帰着日は無条件に△にしてる 手抜き？ by山田修正
    if (beginDate === endDate) {
      // 終日空き
      if (beginTime === '00:00:00' && endTime === '23:59:59') {
        states[time.format('Y-m-d', begin)] = 'c-cell--empty'
      } else {
        if (calendarType !== 1) {
          states[time.format('Y-m-d', begin)] = 'c-cell--afew'
        }
      }
    } else {
      if (beginTime === '00:00:00') {
        states[time.format('Y-m-d', begin)] = 'c-cell--empty'
      } else {
        if (calendarType !== 1) {
          states[time.format('Y-m-d', begin)] = 'c-cell--afew'
        }
      }
      if (endTime === '23:59:59') {
        states[time.format('Y-m-d', end)] = 'c-cell--empty'
      } else {
        if (calendarType !== 1) {
          states[time.format('Y-m-d', end)] = 'c-cell--afew'
        }
      }
    }

    // 期間の日付は終日予約可にする
    begin.setDate(begin.getDate() + 1)
    begin.setHours(0, 0, 0, 0)
    end.setHours(0, 0, 0, 0)
    while (begin.getTime() < end.getTime()) {
      states[time.format('Y-m-d', begin)] = 'c-cell--empty'
      begin.setDate(begin.getDate() + 1)
    }
  }

  return states
}
